export const DEFAULT_REVIEWS_NUMBER: number = 105;
export const DEFAULT_REVIEWS_RATING: number = 4.6;

export const DEFAULT_LOCALE: string = "it"
export const DEFAULT_ROUTE: string = "intro"

export const HABACUS_STATIC_URL: string = process.env.APP_ENV === "staging" ? "https://static.test.habacus.com" : "https://static.habacus.com";
export const WHATSAPP_NUMBER: string = "+393488206605"; // "+393492360070";